import React from 'react';
import classNames from 'classnames';
import styles from './assets/serviceLocation-create-screen.module.scss';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/ServiceLocationForm';
import Breadcrumbs from 'src/components/Breadcrumbs';
import { routes } from 'src/navigation';

const ServiceLocationCreateScreen: React.FunctionComponent = () => (
    <AdminLayout>
        <Breadcrumbs
            items={[
                { name: 'SERVICE LOCATIONS', path: routes.SERVICE_LOCATIONS_LIST },
                { name: `ADD NEW SERVICE LOCATION`, path: '' },
            ]}
        />
        <div className={classNames(styles.createWrapForm)}>
            <Form initialValues={{ isPrivate: false, description: ' ' }} />
        </div>
    </AdminLayout>
);

export default ServiceLocationCreateScreen;
